import { format } from 'date-fns';
import { NumberUtils } from 'modules';
import type { OilPaymentInfoBank } from 'services/openapi';

export const EMPTY_DISPLAY_VALUE = '--';

export const isEmptyDisplayValue = (value: any) =>
  value === undefined ||
  value === null ||
  value === '' ||
  String(value).trim() === EMPTY_DISPLAY_VALUE;

export const hasDisplayValue = (value: any) => !isEmptyDisplayValue(value);

export const hasBankInformation = (bank?: OilPaymentInfoBank) => {
  if (!bank) return false;

  return [
    bank.bankAccountName,
    bank.bankAccountNumber,
    bank.name,
    bank.shortName,
    bank.code,
  ].some(hasDisplayValue);
};

export const formatDisplayDateTime = (
  value?: string,
  fallback = EMPTY_DISPLAY_VALUE,
) => {
  if (!value) return fallback;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return format(date, 'HH:mm:ss dd/MM/yyyy');
};

export const formatDisplayAmount = (
  value?: number,
  fallback = EMPTY_DISPLAY_VALUE,
) =>
  value || value === 0 ? NumberUtils.toFormatNumber(Number(value)) : fallback;

export const getTransactionStatusToneClass = (status?: string) => {
  switch (status) {
    case 'Thành công':
    case 'Hoàn thành':
      return 'is-success';
    case 'Thất bại':
    case 'Đã hủy':
      return 'is-danger';
    case 'Đang xử lý':
      return 'is-info';
    default:
      return 'is-warning';
  }
};
